import type { TerminalTheme } from "@/lib/terminal/use-terminal-theme"

// The Night Shift mark as the showcase itself, small: the torch sweeps and
// reveals the grain on a continuous 12.2-second loop. Both files come from
// the identity workbench's locked design (COMPANY
// sites/nightshift-identity-workbench, lock "10/8"). Reduced motion gets the
// still mark at the same geometry, never the thinner small-size redraw.
// Without a size, the caller's className sizes it (the sign-in showcase).
export function TerminalLogo({
  size,
  theme,
  isDecorative = false,
  className,
}: {
  size?: number
  theme: TerminalTheme
  isDecorative?: boolean
  className?: string
}) {
  const assetRoot = `/assets/night-shift/mark`
  return (
    <picture
      className={className}
      style={{ display: "block", flex: "none", width: size, height: size }}
    >
      <source
        media="(prefers-reduced-motion: reduce)"
        srcSet={`${assetRoot}-${theme}.svg`}
      />
      <img
        src={`${assetRoot}-animated-${theme}.svg`}
        alt={isDecorative ? "" : "Night Shift"}
        width={size}
        height={size}
        style={{ display: "block" }}
      />
    </picture>
  )
}
